import { useMemo, useState } from "react";

const addDays = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
};

const toInputDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const NotificationPauseModal = ({ participant, onClose, onSaved }) => {
  const tomorrow = useMemo(() => toInputDate(addDays(new Date(), 1)), []);
  const [startsAt, setStartsAt] = useState(tomorrow);
  const [endsAt, setEndsAt] = useState(tomorrow);
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const maxEndDate = useMemo(() => {
    const startDate = startsAt ? new Date(`${startsAt}T00:00:00`) : new Date();
    return toInputDate(addDays(startDate, 180));
  }, [startsAt]);

  if (!participant) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSaving(true);

    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/participants/${participant.id}/notification-pauses`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({ startsAt, endsAt }),
        },
      );
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(result.message || "Could not save pause dates.");
      }
      onSaved?.();
      onClose();
    } catch (err) {
      setError(err.message || "Could not save pause dates.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <h3 className="text-lg font-black text-gray-900">Pause RSVP texts</h3>
        <p className="mt-2 text-sm text-gray-600">
          Pause future RSVP pings for {participant.name}. Start date must be
          tomorrow or later, up to 180 days.
        </p>
        <form onSubmit={handleSubmit} className="mt-4 space-y-4">
          <label className="block text-sm font-bold text-gray-700">
            Start date
            <input
              type="date"
              min={tomorrow}
              value={startsAt}
              onChange={(event) => setStartsAt(event.target.value)}
              className="mt-1 w-full rounded-lg border border-gray-300 p-2"
              required
            />
          </label>
          <label className="block text-sm font-bold text-gray-700">
            End date
            <input
              type="date"
              min={startsAt || tomorrow}
              max={maxEndDate}
              value={endsAt}
              onChange={(event) => setEndsAt(event.target.value)}
              className="mt-1 w-full rounded-lg border border-gray-300 p-2"
              required
            />
          </label>
          {error && (
            <p className="text-sm font-semibold text-red-600">{error}</p>
          )}
          <div className="flex justify-end gap-3">
            <button type="button" onClick={onClose} className="btn btn-ghost">
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSaving}
              className="rounded-lg bg-[#004a7e] px-4 py-2 font-bold text-white disabled:opacity-50"
            >
              {isSaving ? "Saving..." : "Save pause"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NotificationPauseModal;
